import {modalAnatomy as parts} from '@chakra-ui/anatomy'
import {defineStyle} from '@chakra-ui/react'
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'

import borders from '../foundations/borders'
import colors from '../foundations/colors'
import opacity from '../foundations/opacity'
import shadow from '../foundations/shadow'
import dimension from '../foundations/sizes'
import typography from '../foundations/typography'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  overlay: {
    opacity: opacity[80],
  },
  dialog: {
    borderRadius: borders.radii.sm,
    bg: colors.background.primary,
    shadow: shadow['2xl'],
    minH: dimension['5xl'],
  },
  header: {
    color: colors.text.primary,
    ...typography.textStyles.subheading.large,
  },
  body: {
    color: colors.text.secondary,
    ...typography.textStyles.body.medium,
  },
  closeButton: {
    borderRadius: borders.radii['2xs'],
    _hover: {
      bg: colors.background['primary-hover'],
    },
    _active: {
      bg: colors.background['primary-active'],
    },
  },
})
const sizes = {
  xs: definePartsStyle({
    body: defineStyle({
      maxW: '246px',
    }),
  }),
  sm: definePartsStyle({
    body: defineStyle({
      maxW: dimension['7xl'],
    }),
  }),
  md: definePartsStyle({
    body: defineStyle({
      maxW: '640px',
    }),
  }),
  lg: definePartsStyle({
    body: defineStyle({
      maxW: '896px',
    }),
  }),
}

const modalTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
})

export default modalTheme
